import * as React from "react";
const SvgImageIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.3712 13.6455L10.0786 12.4682C9.44458 11.8909 9.12759 11.6022 8.76835 11.4928C8.45196 11.3965 8.11407 11.3965 7.79768 11.4928C7.43843 11.6022 7.12144 11.8909 6.48747 12.4682L3.48417 14.9997M11.3712 13.6455L11.6345 13.4057C12.2685 12.8284 12.5855 12.5397 12.9447 12.4303C13.2611 12.334 13.599 12.334 13.9154 12.4303C14.2746 12.5397 14.5916 12.8284 15.2256 13.4057L16.5832 14.6998M11.3712 13.6455L14.3087 16.6322M7.33203 16.6663H12.6654C14.0655 16.6663 14.7656 16.6663 15.3003 16.3939C15.7707 16.1542 16.1532 15.7717 16.3929 15.3013C16.6654 14.7665 16.6654 14.0665 16.6654 12.6663V7.33301C16.6654 5.93288 16.6654 5.23281 16.3929 4.69803C16.1532 4.22763 15.7707 3.84517 15.3003 3.60549C14.7656 3.33301 14.0655 3.33301 12.6654 3.33301H7.33203C5.9319 3.33301 5.23183 3.33301 4.69705 3.60549C4.22665 3.84517 3.8442 4.22763 3.60451 4.69803C3.33203 5.23281 3.33203 5.93288 3.33203 7.33301V12.6663C3.33203 14.0665 3.33203 14.7665 3.60451 15.3013C3.8442 15.7717 4.22665 16.1542 4.69705 16.3939C5.23183 16.6663 5.9319 16.6663 7.33203 16.6663ZM14.1654 7.49967C14.1654 8.42015 13.4192 9.16634 12.4987 9.16634C11.5782 9.16634 10.832 8.42015 10.832 7.49967C10.832 6.5792 11.5782 5.83301 12.4987 5.83301C13.4192 5.83301 14.1654 6.5792 14.1654 7.49967Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgImageIcon;
